function initAnimateIn() {

    gsap.registerPlugin(ScrollTrigger);
    // For each images with class "animate-image" on page
    gsap.utils.toArray('.animate-in').forEach((el, index) => { 

       el.style.opacity = 0; 
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          toggleActions: "play none none reverse",
           //markers: true
        }
      })

      tl
      .set(el, {transformOrigin: 'center center'})
      .fromTo(el, { opacity: 0,  y: "+=70"}, {opacity: 1,  y: 0, duration: 1.2, delay:0.1, immediateRender: false})
    });
}

 
